/**
 * Colour tokens for the user-facing site. Admin and creator pages are not wired
 * to this folder, so they keep the plain MUI defaults.
 *
 * Changing the site's season (dark now, light next, dark again) is a change to
 * this one file: keep the token names, swap the values, and every user page
 * follows. `muiTheme.js` hands these to MUI (cards, dialogs, chips, text) and
 * `surfaces.js` builds the hand-rolled surfaces MUI never sees.
 */

/** Drives the MUI palette mode so component defaults flip with the tokens. */
export const THEME_MODE = "dark";

/** Backdrop behind every user page, including the immersive board shell. */
export const SITE_BG = "#0f172a";

export const SURFACE = {
    /** Cards, dialogs, menus — whatever MUI calls `background.paper`. */
    card: "#18233c",
    /** Chrome: header and navigation drawer. */
    chrome: "#111a2e",
    /** Panels floating over the mist: play toolbars, trays, access gate. */
    panel: "rgba(17, 26, 46, 0.82)",
    /** Inset wells: previews, empty slots, progress tracks. */
    sunken: "#0b1220",
    border: "rgba(148, 163, 184, 0.28)",
    borderStrong: "rgba(148, 163, 184, 0.45)",
    hover: "rgba(148, 163, 184, 0.14)",
};

export const TEXT = {
    primary: "#eef4ff",
    secondary: "rgba(226, 232, 240, 0.74)",
    disabled: "rgba(148, 163, 184, 0.45)",
};

/** Brand green: carries the logo, play actions and progress across every season. */
export const ACCENT = {
    main: "#3BA666",
    dark: "#2e7d32",
    light: "#7BDCA5",
    soft: "rgba(59, 166, 102, 0.16)",
    contrastText: "#ffffff",
};

/** Tinted callouts (plan notes, billing warnings) that used to be pastel blocks. */
export const NOTICE = {
    info: {
        bg: "rgba(56, 132, 255, 0.14)",
        border: "rgba(96, 165, 250, 0.5)",
        text: "#dbeafe",
    },
    warning: {
        bg: "rgba(234, 179, 8, 0.14)",
        border: "rgba(250, 204, 21, 0.5)",
        text: "#fef3c7",
    },
};

export const SHADOW = {
    card: "0 10px 28px rgba(2, 6, 18, 0.38)",
    cardHover: "0 16px 36px rgba(2, 6, 18, 0.5)",
    chrome: "0 2px 10px rgba(2, 6, 18, 0.45)",
};
